/**
 * UserAccountGridLeft
 * -------------------
 * Left sidebar column for the Oowlet UserFeed 3-column grid layout.
 * Renders the advertisement cards (from ads data) in stacked slots.
 * Stays fixed to the viewport height; the centre column scrolls independently.
 * Hidden on mobile via CSS media query (max-width: 768px).
 */

import advertisements from "../Utils/ads";        // adjust path to ads.js
import { AdvertisementCard } from "../Utils/AdvertisementCard"; // adjust path
import "../UserAccountGridLayout.css";

const MAX_ADS = 2;

const UserAccountGridLeft = ({ slotPrefix = "uaf-left" }) => {
  const visibleAds = advertisements.slice(0, MAX_ADS);

  return (
    /* grid-area: left — occupies the leftmost column of .uaf-page-grid */
    <aside
      className="uaf-left-sidebar"
      aria-label="Left advertisement column"
      style={{ marginTop: 60 }}
    >
      <div className="uaf-sidebar-inner">
        {visibleAds.length === 0 ? (
          <div className="uaf-ad-slot" role="complementary" aria-label="Advertisement slot">
            <span className="uaf-ad-placeholder-label">
              No sponsored placements right now.
            </span>
          </div>
        ) : (
          visibleAds.map((ad, index) => (
            <div
              key={ad.id}
              className="uaf-ad-slot"
              id={`${slotPrefix}-ad-${index + 1}`}
              role="complementary"
              aria-label={`Advertisement slot ${index + 1}`}
              style={{gap: 50, marginTop: 80}}
            >
              <AdvertisementCard ad={ad} />
            </div>
          ))
        )}
      </div>
    </aside>
  );
};

export default UserAccountGridLeft;